import { useCallback } from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import TableRowExpandable from 'app/components/TableRowExpandable';
import ToolstringTemplateToolsTable from 'features/projects/tasks/task/toolstring/components/ToolstringTemplateToolsTable';

import { getUnitsOfMeasurePreference } from 'features/equipment/equipment.selectors';
import { getUnitsPreference } from 'features/wells/sections/wellboreSection.selectors';
import { wellSectionUoM } from 'features/wells/sections/helpers/utils';

const ToolstringTemplateTableRow = ({ item, ...rest }) => {
  const unitsOfMeasurePreference = useSelector(getUnitsOfMeasurePreference);
  const selectedUnit = useSelector(getUnitsPreference);

  const [UoM, setUoM] = useState();

  useEffect(() => {
    setUoM(wellSectionUoM(unitsOfMeasurePreference, selectedUnit));
  }, [unitsOfMeasurePreference, selectedUnit]);

  const renderDetails = useCallback(
    (isRowExpanded) => {
      return isRowExpanded ? (
        <ToolstringTemplateToolsTable
          templateId={item.get('id')}
          toolstringItems={item.get('toolsByToolstringToolId')}
          UoM={UoM}
        />
      ) : null;
    },
    [item, UoM],
  );

  return (
    <TableRowExpandable item={item} {...rest} renderDetails={renderDetails} />
  );
};

export default ToolstringTemplateTableRow;
